/**
 * Returns url for image src
 * assetsBaseUrl - available in page redux slice
 * iconFileName - include the folder if it's not in root
 */
export default function assetUrlGenerator(assetsBaseUrl: string, iconFileName: string): string {
    const iconRelativePath = `/apps/shared-images/${window.sharedImagesVersion}/images/${iconFileName}`;
    return `${assetsBaseUrl || ""}${iconRelativePath}`
}